import { render, staticRenderFns } from "./DishRatingsContainer.vue?vue&type=template&id=2237b0f5&"
import script from "./DishRatingsContainer.vue?vue&type=script&lang=js&"
export * from "./DishRatingsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DishRatingsContainer.vue"
export default component.exports